// @ts-nocheck
import { TECFinanceCompanyModel } from "@store/Framework/Types/ApiModels";
import {
    getTECFinanceCompanies,
    GetTECFinanceCompaniesApiParameter,
} from "@store/Framework/Services/TaxExemptionCertificatesService";
import { ApiHandler, createHandlerChainRunner } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandler<GetTECFinanceCompaniesApiParameter, TECFinanceCompanyModel>;

export const DispatchBeginLoadTECFinanceCompanies: HandlerType = props => {
    props.dispatch({
        type: "Greif/Data/TECFinanceCompanies/BeginLoadTECFinanceCompanies",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getTECFinanceCompanies(props.apiParameter);
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 404)) {
            props.dispatch({
                type: "Greif/Data/TECFinanceCompanies/FailedToLoadTECFinanceCompanies",
            });
            return false;
        }

        throw error;
    }
};

export const DispatchCompleteLoadTECFinanceCompanies: HandlerType = props => {
    props.dispatch({
        type: "Greif/Data/TECFinanceCompanies/CompleteLoadTECFinanceCompanies",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadTECFinanceCompanies,
    RequestDataFromApi,
    DispatchCompleteLoadTECFinanceCompanies,
];

const loadTECFinanceCompanies = createHandlerChainRunner(chain, "LoadTECFinanceCompanies");
export default loadTECFinanceCompanies;
